/**
 * Estilos compartidos de las pantallas de acceso (login, invitación,
 * recuperar y restablecer contraseña) para que todas se vean iguales.
 */
export const AUTH_CSS = `
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        /* ── Fondo general ── */
        .lp-bg {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #080e18;
          font-family: 'Montserrat', sans-serif;
          padding: 24px 16px;
          position: relative;
          overflow: hidden;
        }

        /* Glow de fondo */
        .lp-bg::before {
          content: '';
          position: fixed;
          width: 800px;
          height: 800px;
          background: radial-gradient(circle, rgba(249,115,22,0.09) 0%, transparent 65%);
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          pointer-events: none;
        }

        /* ── Navbar superior ── */
        .lp-nav {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          padding: 16px 28px;
          display: flex;
          align-items: center;
          gap: 10px;
          z-index: 10;
          background: rgba(8,14,24,0.7);
          backdrop-filter: blur(12px);
          border-bottom: 1px solid rgba(229,236,245,0.04);
        }

        .lp-nav img {
          width: 24px;
          height: 24px;
          object-fit: contain;
        }

        .lp-nav-word {
          font-size: 1rem;
          font-weight: 800;
          letter-spacing: 2px;
          text-transform: uppercase;
        }
        .lp-nav-word .cor  { color: #f97316; }
        .lp-nav-word .vian { color: #e5ecf5; }

        /* ── Card central ── */
        .lp-card {
          position: relative;
          z-index: 2;
          display: grid;
          grid-template-columns: 320px 380px;
          border-radius: 20px;
          overflow: hidden;
          box-shadow:
            0 0 0 1px rgba(249,115,22,0.15),
            0 32px 80px rgba(0,0,0,0.6),
            0 0 60px rgba(249,115,22,0.06);
          max-width: 700px;
          width: 100%;
        }

        /* ════════════════════════════
           PANEL IZQUIERDO — naranja
        ════════════════════════════ */
        .lp-panel-left {
          background: #f97316;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          padding: 40px 32px 32px;
          position: relative;
          overflow: hidden;
        }

        .lp-panel-left::before {
          content: '';
          position: absolute;
          inset: 0;
          background-image: radial-gradient(circle, rgba(0,0,0,0.15) 1px, transparent 1px);
          background-size: 22px 22px;
          pointer-events: none;
        }

        .lp-panel-left::after {
          content: '';
          position: absolute;
          top: -80px;
          left: -80px;
          width: 280px;
          height: 280px;
          background: radial-gradient(circle, rgba(255,255,255,0.12) 0%, transparent 65%);
          pointer-events: none;
        }

        .lp-brand-center {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0;
          flex: 1;
          justify-content: center;
        }

        .lp-logo-box {
          width: 76px;
          height: 76px;
          background: rgba(0,0,0,0.22);
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 22px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.25);
        }

        .lp-logo-box img {
          width: 46px;
          height: 46px;
          object-fit: contain;
          filter: brightness(0) invert(1);
        }

        .lp-brand-name {
          font-size: 2.4rem;
          font-weight: 900;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: #1a0a00;
          line-height: 1;
          margin-bottom: 8px;
        }

        .lp-brand-sub {
          font-size: 0.62rem;
          font-weight: 700;
          letter-spacing: 4px;
          text-transform: uppercase;
          color: rgba(0,0,0,0.45);
        }

        .lp-status {
          position: relative;
          z-index: 1;
          display: flex;
          align-items: center;
          gap: 8px;
          background: rgba(0,0,0,0.18);
          border-radius: 30px;
          padding: 8px 16px;
          width: 100%;
          justify-content: center;
        }

        .lp-status-dot {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #1a0a00;
          opacity: 0.6;
          animation: lp-pulse 2s ease-in-out infinite;
        }

        @keyframes lp-pulse {
          0%, 100% { opacity: 0.6; transform: scale(1); }
          50%       { opacity: 1;   transform: scale(1.2); }
        }

        .lp-status span {
          font-size: 0.68rem;
          font-weight: 700;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          color: rgba(0,0,0,0.55);
        }

        /* ════════════════════════════
           PANEL DERECHO — form
        ════════════════════════════ */
        .lp-panel-right {
          background: #111827;
          padding: 44px 36px 36px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .lp-form-title {
          font-size: 1.45rem;
          font-weight: 700;
          color: #e5ecf5;
          letter-spacing: -0.3px;
          margin-bottom: 6px;
        }

        .lp-form-sub {
          font-size: 0.78rem;
          color: rgba(229,236,245,0.35);
          margin-bottom: 30px;
          font-weight: 400;
        }

        /* ── Error API ── */
        .lp-api-err {
          background: rgba(248,113,113,0.07);
          border: 1px solid rgba(248,113,113,0.2);
          border-left: 3px solid #f87171;
          border-radius: 8px;
          padding: 10px 13px;
          margin-bottom: 18px;
          color: #fca5a5;
          font-size: 0.77rem;
          display: flex;
          align-items: center;
          gap: 8px;
          font-weight: 500;
        }

        /* ── Campo ── */
        .lp-field { margin-bottom: 18px; }

        .lp-field-label {
          display: block;
          font-size: 0.67rem;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
          color: rgba(229,236,245,0.38);
          margin-bottom: 8px;
        }

        .lp-field-wrap { position: relative; }

        .lp-input {
          width: 100%;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(229,236,245,0.08);
          border-radius: 10px;
          padding: 12px 14px 12px 14px;
          color: #e5ecf5;
          font-family: 'Montserrat', sans-serif;
          font-size: 0.88rem;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
        }

        .lp-input-icon {
          position: absolute;
          right: 13px;
          top: 50%;
          transform: translateY(-50%);
          color: rgba(229,236,245,0.18);
          font-size: 0.82rem;
          pointer-events: none;
          transition: color 0.2s;
        }

        .lp-field-wrap:focus-within .lp-input-icon {
          color: rgba(249,115,22,0.6);
        }

        .lp-input::placeholder { color: rgba(229,236,245,0.18); }

        .lp-input:focus {
          border-color: rgba(249,115,22,0.55);
          background: rgba(249,115,22,0.03);
          box-shadow: 0 0 0 3px rgba(249,115,22,0.09);
        }

        .lp-input-err {
          border-color: rgba(248,113,113,0.4) !important;
          box-shadow: 0 0 0 3px rgba(248,113,113,0.07) !important;
        }

        .lp-eye {
          position: absolute;
          right: 11px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          color: rgba(229,236,245,0.22);
          cursor: pointer;
          font-size: 0.82rem;
          padding: 4px;
          transition: color 0.2s;
          line-height: 1;
        }
        .lp-eye:hover { color: #f97316; }

        .lp-ferr {
          display: flex;
          align-items: center;
          gap: 5px;
          color: #f87171;
          font-size: 0.7rem;
          font-weight: 600;
          margin-top: 5px;
        }

        /* ── Botón submit ── */
        .lp-btn {
          width: 100%;
          background: #f97316;
          border: none;
          border-radius: 10px;
          padding: 13px;
          color: #fff;
          font-family: 'Montserrat', sans-serif;
          font-size: 0.85rem;
          font-weight: 700;
          letter-spacing: 0.5px;
          cursor: pointer;
          transition: background 0.2s, box-shadow 0.2s, transform 0.1s;
          margin-top: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
        }

        .lp-btn:hover:not(:disabled) {
          background: #ea6b10;
          box-shadow: 0 8px 28px rgba(249,115,22,0.28);
          transform: translateY(-1px);
        }

        .lp-btn:active:not(:disabled) { transform: translateY(0); }
        .lp-btn:disabled { opacity: 0.5; cursor: not-allowed; }

        @keyframes lp-spin { to { transform: rotate(360deg); } }
        .lp-spin { animation: lp-spin 0.75s linear infinite; display: inline-block; }

        /* ════════════════════════════
           LIGHT THEME OVERRIDES
        ════════════════════════════ */
        [data-theme="light"] .lp-bg {
          background: #f0f4f8;
        }
        [data-theme="light"] .lp-bg::before {
          background: radial-gradient(circle, rgba(249,115,22,0.06) 0%, transparent 65%);
        }
        [data-theme="light"] .lp-nav {
          background: rgba(240, 244, 248, 0.88);
          backdrop-filter: blur(12px);
          border-bottom: 1px solid rgba(0,0,0,0.08);
        }
        [data-theme="light"] .lp-nav-word .vian {
          color: #1e293b;
        }
        [data-theme="light"] .lp-card {
          box-shadow:
            0 0 0 1px rgba(249,115,22,0.12),
            0 24px 60px rgba(0,0,0,0.14),
            0 0 40px rgba(249,115,22,0.04);
        }
        [data-theme="light"] .lp-panel-right {
          background: #ffffff;
          border-left: 1px solid rgba(0,0,0,0.06);
        }
        [data-theme="light"] .lp-form-title {
          color: #0f172a;
        }
        [data-theme="light"] .lp-form-sub {
          color: #6b7280;
        }
        [data-theme="light"] .lp-field-label {
          color: #6b7280;
        }
        [data-theme="light"] .lp-input {
          background: #f8fafc;
          border: 1px solid #d1d5db;
          color: #0f172a;
        }
        [data-theme="light"] .lp-input::placeholder {
          color: #94a3b8;
        }
        [data-theme="light"] .lp-input:focus {
          background: #f0f4f8;
          border-color: rgba(249,115,22,0.55);
          box-shadow: 0 0 0 3px rgba(249,115,22,0.10);
        }
        [data-theme="light"] .lp-input-icon {
          color: #94a3b8;
        }
        [data-theme="light"] .lp-field-wrap:focus-within .lp-input-icon {
          color: #f97316;
        }
        [data-theme="light"] .lp-eye {
          color: #94a3b8;
        }
        [data-theme="light"] .lp-form-foot {
          color: #9ca3af;
          border-top-color: rgba(0,0,0,0.06);
        }
        [data-theme="light"] .lp-nav-btn {
          border-color: rgba(0,0,0,0.15);
          color: #374151;
        }
        [data-theme="light"] .lp-nav-btn:hover {
          background: rgba(249,115,22,0.08);
          border-color: rgba(249,115,22,0.35);
          color: #f97316;
        }

        /* ── Nav utility buttons ── */
        .lp-nav-util {
          margin-left: auto;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .lp-nav-btn {
          background: transparent;
          border: 1px solid rgba(229, 236, 245, 0.18);
          border-radius: 7px;
          padding: 5px 11px;
          color: rgba(229, 236, 245, 0.55);
          cursor: pointer;
          font-family: 'Montserrat', sans-serif;
          font-size: 0.68rem;
          font-weight: 700;
          letter-spacing: 0.5px;
          line-height: 1;
          transition: background 0.15s, border-color 0.15s, color 0.15s;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 28px;
          min-width: 28px;
        }
        .lp-nav-btn:hover {
          background: rgba(249, 115, 22, 0.10);
          border-color: rgba(249, 115, 22, 0.35);
          color: #f97316;
        }

        /* ── Footer del form ── */
        .lp-form-foot {
          margin-top: 24px;
          padding-top: 18px;
          border-top: 1px solid rgba(229,236,245,0.05);
          text-align: center;
          font-size: 0.68rem;
          color: rgba(229,236,245,0.18);
          font-weight: 500;
        }

        .lp-form-foot strong { color: rgba(249,115,22,0.7); }

        /* ════════════════════════════
           RESPONSIVE
        ════════════════════════════ */
        @media (max-width: 680px) {
          .lp-card {
            grid-template-columns: 1fr;
            max-width: 400px;
            border-radius: 16px;
          }

          .lp-panel-left {
            padding: 32px 28px 28px;
            min-height: 240px;
          }

          .lp-logo-box {
            width: 60px;
            height: 60px;
            border-radius: 14px;
            margin-bottom: 16px;
          }

          .lp-logo-box img { width: 36px; height: 36px; }

          .lp-brand-name { font-size: 1.9rem; }

          .lp-panel-right {
            padding: 32px 28px 28px;
          }
        }

        @media (max-width: 420px) {
          .lp-bg { padding: 0; align-items: stretch; justify-content: flex-start; }
          .lp-card {
            border-radius: 0;
            box-shadow: none;
            max-width: 100%;
            min-height: 100vh;
          }
          .lp-panel-right { justify-content: flex-start; padding-top: 40px; }
        }

        /* ── Variante de una sola columna (invitación / recuperar) ── */
        .lp-card.lp-card-single {
          grid-template-columns: 1fr;
          max-width: 460px;
        }
        .lp-card-single .lp-panel-right { padding: 38px 36px 30px; }
        .lp-ok {
          display: flex; align-items: flex-start; gap: 8px;
          background: rgba(74,222,128,0.08); border: 1px solid rgba(74,222,128,0.3);
          color: #4ade80; border-radius: 9px; padding: 10px 13px;
          font-size: 0.8rem; margin-bottom: 16px; line-height: 1.45;
        }
        .lp-link {
          background: none; border: none; padding: 0; cursor: pointer;
          color: #f97316; font-weight: 600; font-size: 0.78rem;
          font-family: inherit; text-decoration: none;
        }
        .lp-link:hover { text-decoration: underline; }
        .lp-row-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
        @media (max-width: 420px) { .lp-row-2 { grid-template-columns: 1fr; } }
        .lp-chip {
          display: inline-flex; align-items: center; gap: 7px;
          background: rgba(249,115,22,0.1); border: 1px solid rgba(249,115,22,0.3);
          color: #f97316; border-radius: 999px; padding: 4px 12px;
          font-size: 0.74rem; font-weight: 700; margin-bottom: 14px; align-self: flex-start;
        }
        .lp-hint { font-size: 0.72rem; color: #64748b; margin-top: 5px; line-height: 1.4; }
`;
